import {newAxios} from './index'


export const Req_GetCurrencyList = function (data) {
  return newAxios({
    url:`/i/tenant/finance/currency/list`,
    data
  })()
}

export const Req_GetAssistList = function (data) {
  return newAxios({
    url: `/i/tenant/finance/subject/bean/assist`,
    data
  })()
}


export const Req_SubmitSupplier = function (data){
  const url = data.supplierId ? '/i/tenant/finance/customer/supplier/update' : '/i/tenant/finance/customer/supplier/add'
  return newAxios({
    url,
    data
  },'json')()
}


export const Req_CheckIsExist = function(data) {
  return newAxios({
    url:'/i/tenant/finance/customer/inner/check/is/exist',
    data
  },'',true,true)()
}


export const Req_GetSupplierAllList = function (data) {
  return newAxios({
    url:`/i/tenant/finance/customer/supplier/list`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/supplier.js